import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_2 = { class: "overflow-x-auto" }
const _hoisted_3 = { class: "align-middle inline-block min-w-full" }
const _hoisted_4 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_5 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, " Date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, " Contract "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, " Order "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500"
    }, " Time ")
  ])
], -1)
const _hoisted_7 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "100%",
  class: "px-3 py-2 text-gray-500 text-sm"
}, "No records for selected date range.", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_12 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_13 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_14 = { class: "px-3 py-2 text-sm" }
const _hoisted_15 = { class: "mx-2 text-xs font-semibold text-center p-1 rounded-md text-green-600 bg-green-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("tbody", _hoisted_7, [
                  (_ctx.report.length == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report, (record) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: record.contract + record.orderLabel,
                      class: "hover:bg-gray-100"
                    }, [
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(record.date), 1)
                      ]),
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("span", null, _toDisplayString(record.contract), 1)
                      ]),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("span", null, _toDisplayString(record.orderLabel), 1)
                      ]),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getTime(record.minutes)), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}